import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import { fetchFilteredTiles, setActiveCategoryId, setActiveSubCategories, resetTiles } from '../../../../Base/Actions';

import FlyoutView from './FlyoutView';

class FlyoutController extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subcategories: [],
      visible: false,
    };

    this.addActiveSubCategory = this.addActiveSubCategory.bind(this);
    this.removeActiveSubCategory = this.removeActiveSubCategory.bind(this);
    this.toggleActiveSubCategory = this.toggleActiveSubCategory.bind(this);
    this.unsetAllSubCategories = this.unsetAllSubCategories.bind(this);
    this.filterTiles = this.filterTiles.bind(this);
    this.isActiveSubCategory = this.isActiveSubCategory.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      subcategories: nextProps.subcategories,
      visible: nextProps.visible,
    });
  }

  addActiveSubCategory(category) {
    const id = category.id;
    const activeCategories = { ...this.props.activeSubCategories };
    activeCategories[id] = category;

    this.props.setActiveSubCategories(activeCategories);
    this.props.setHashByActiveSubCategories(activeCategories);
  }

  removeActiveSubCategory(category) {
    const id = category.id;
    const activeCategories = { ...this.props.activeSubCategories };
    if (activeCategories[id]) {
      delete activeCategories[id];
    }

    this.props.setActiveSubCategories(activeCategories);
    this.props.setHashByActiveSubCategories(activeCategories);
  }

  toggleActiveSubCategory(category) {
    if (this.props.activeSubCategories[category.id]) {
      this.removeActiveSubCategory(category);
    } else {
      this.addActiveSubCategory(category);
    }
  }

  unsetAllSubCategories() {
    this.props.setActiveSubCategories({});
  }

  isActiveSubCategory(category) {
    return this.props.activeSubCategories.hasOwnProperty(category.id);
  }

  filterTiles(e) {
    if (e) {
      e.preventDefault();
    }
    this.props.setHashByActiveSubCategories(this.props.activeSubCategories);
    this.props.closeFlyout();
  }

  render() {
    if (this.state.visible) {
      return (<FlyoutView
        {...this.props}
        visible={this.state.visible}
        subcategories={this.state.subcategories}
        addActiveSubCategory={this.addActiveSubCategory}
        removeActiveSubCategory={this.removeActiveSubCategory}
        toggleActiveSubCategory={this.toggleActiveSubCategory}
        unsetAllSubCategories={this.unsetAllSubCategories}
        filterTiles={this.filterTiles}
        isActiveSubCategory={this.isActiveSubCategory}
      />);
    }
    return null;
  }
}

FlyoutController.propTypes = {
  visible: PropTypes.bool,
  subcategories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    img: PropTypes.string,
    title: PropTypes.string,
  })),
  lang: PropTypes.string,
  history: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
  fetchFilteredTiles: PropTypes.func.isRequired,
  setActiveSubCategories: PropTypes.func.isRequired,
  setActiveCategoryId: PropTypes.func.isRequired,
  closeFlyout: PropTypes.func.isRequired,
  resetTiles: PropTypes.func.isRequired,
  setHashByActiveSubCategories: PropTypes.func.isRequired,
  activeSubCategories: PropTypes.shape(),
};

FlyoutController.defaultProps = {
  visible: false,
  subcategories: [],
  activeSubCategories: {},
  activeSubCategory: {},
  lang: 'en',
};


function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchFilteredTiles, setActiveSubCategories, setActiveCategoryId, resetTiles }, dispatch);
}


function mapStateToProps(state) {
  return {
    lang: state.globalsState.lang,
    subcategories: state.navState.subcategories,
    activeSubCategories: state.navState.activeSubCategories,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FlyoutController));



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/Flyout/FlyoutController.jsx